import { render, staticRenderFns } from "./squaread-add-or-update.vue?vue&type=template&id=e6f8116c"
import script from "./squaread-add-or-update.vue?vue&type=script&lang=js"
export * from "./squaread-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./squaread-add-or-update.vue?vue&type=style&index=0&id=e6f8116c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports